import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import { useMemo } from 'react';

import { type PaginationItem } from '../../../types/pagination';
import { getTotalPagesCount } from '../utils/getTotalPagesCount';
import { preparePagination } from '../utils/preparePagination';

type Pagination = {
  pages: PaginationItem[];
  nextPage: PaginationItem;
  prevPage: PaginationItem;
};

type Params = {
  maxPage: number | null;
  offersPerPage: number;
  page: number;
  totalOffers: number;
};

export function usePagination(params: Params): Pagination {
  const { page, offersPerPage, totalOffers, maxPage } = params;

  const totalPages = getTotalPagesCount(offersPerPage, totalOffers, maxPage);

  const pages = useMemo(
    () => (totalPages > 1 ? preparePagination({ currentPage: page, totalPages }) : []),
    [page, totalPages],
  );

  const prevPage = useMemo<PaginationItem>(
    () => ({
      disabled: page === 1,
      icon: <IconActionChevronLeft16 />,
      id: 'back',
      page: page - 1,
      title: 'Назад',
    }),
    [page],
  );

  const nextPage = useMemo<PaginationItem>(
    () => ({
      disabled: page === totalPages,
      icon: <IconActionChevronRight16 />,
      id: 'forward',
      page: page + 1,
      title: 'Дальше',
    }),
    [page, totalPages],
  );

  return useMemo<Pagination>(
    () => ({
      nextPage,
      pages,
      prevPage,
    }),
    [nextPage, pages, prevPage],
  );
}
